<template>
  <div v-show="isOutputSheetList" id="manufacture_table">
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <!-- 絞り込み検索モーダル -->
    <dd-plan-search-modal
      ref="planSearchRef"
      :isOutputSheetList="isOutputSheetList"
      @onClickSearch="onClickSearch"
    />
    <div class="table_wrapper">
      <!--  タイトルエリア  -->
      <div class="title_area">
        <h3>生産指示 → 指示書出力</h3>
      </div>
      <div class="form_area">
        <div class="button_area">
          <button class="main_btn" @click="openSearchModal">絞り込み条件選択</button>
          <button class="main_btn" @click="downLoadCsv">CSV出力</button>
        </div>
        <!-- ページ -->
        <div>
          <dd-pager
            ref="pagerRef"
            :pageNo="pageNo"
            :dataCountPerPage="dataCount"
            :totalDataCount="totalCount"
            @paging="paging"
          />
        </div>
        <div class="disp_btn" @click="openDispModal">
          <div class="disp_icon">
            <span class="displogo"></span>
            <span class="displogo"></span>
            <span class="displogo"></span>
          </div>
          <div class="disptitle">表示項目</div>
        </div>
      </div>
      <!-- データテーブル -->
      <div class="plan_list_area">
        <table>
          <thead>
            <tr>
              <th class="check_area">出力</th>
              <th :class="{none: checkDisp(0)}">ステータス</th>
              <th :class="{none: checkDisp(1)}">生産日</th>
              <th :class="{none: checkDisp(2)}">計画ID</th>
              <th class="number_area" :class="{none: checkDisp(3)}">プラン個数 </th>
              <th class="number_area" :class="{none: checkDisp(4)}">コンバイン個数</th>
              <th class="number_area" :class="{none: checkDisp(5)}">ユニット個数</th>
              <th class="number_area" :class="{none: checkDisp(6)}">金額</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(plan, index) in dispPlanDataList"
              :key="index"
            >
              <td class="check_area"><button class="list_btn gray_btn" @click="openPreview(plan.planRotCode)"></button></td>
              <td :class="{none: checkDisp(0)}">{{ getDispStatus(plan.planStatus) }}</td>
              <td :class="{none: checkDisp(1)}">{{ getFormatSimpleDate(plan.planManufactureDate) }}</td>
              <td :class="{none: checkDisp(2)}">{{ plan.planRotCode }}</td>
              <td class="number_area" :class="{none: checkDisp(3)}">{{ plan.totalPlanCount }}</td>
              <td class="number_area" :class="{none: checkDisp(4)}">{{ plan.totalCombCount }}</td>
              <td class="number_area" :class="{none: checkDisp(5)}">{{ plan.totalUnitCount }}</td>
              <td class="number_area" :class="{none: checkDisp(6)}">{{ plan.totalCurPrice.toLocaleString() }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import encoding from 'encoding-japanese'
import {API_URL, STORAGE_KEY} from '../../constants/App'
import {LIST_TYPE} from '../../constants/Type'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import PlanSearchModal from '../list/modal/PlanSearchModal'
import ListDispModal from '../list/modal/ListDispModal'
import LoadingModal from '../common/LoadingModal'
import Pager from '../../components/common/OrderPager'

export default {
  name: 'OutputSheetTable',
  components: {
    'dd-plan-search-modal': PlanSearchModal,
    'dd-plan-disp-modal': ListDispModal,
    'dd-pager': Pager,
    'dd-loading-modal': LoadingModal
  },
  props: {
    isOutputSheetList: Boolean,
    customNameList: Array,
    dispForm: Object
  },
  data () {
    return {
      /** ページ番号 */
      pageNo: 1,
      /** 1ページごとの表示件数 */
      dataCount: 14,
      /** 総件数 */
      totalCount: 0,
      /** プランリスト全件 */
      planDataList: [],
      /** 表示用プランリスト */
      dispPlanDataList: [],
      /** 検索条件 */
      searchForm: {
        planStatus: [],
        estimateDateStart: '',
        estimateDateEnd: '',
        manufactureDateStart: '',
        manufactureDateEnd: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        completeDateStart: '',
        completeDateEnd: '',
        planRotCode: '',
        umPlanid: '',
        fileName: '',
        pageNo: '',
        dataCount: ''
      },
      imgCheckMark: this.getImage('pages/list/ic_check.svg')
    }
  },
  watch: {
    /** 受注確定リスト表示フラグ */
    isOutputSheetList: function () {
      if (this.isOutputSheetList) {
        document.addEventListener('mouseup', this.onMouseup)
      } else {
        document.removeEventListener('mouseup', this.onMouseup)
      }
    }
  },
  mounted: function () {
    this.processingDate = this.getFormatDate(new Date())
  },
  methods: {
    /** 生産計画処理リストを取得・表示 */
    getRotDataList: function (isFirstView) {
      if (isFirstView) {
        this.pageNo = 1
        this.$refs.pagerRef.setCurrentPage(this.pageNo)
        this.clear()
      } else {
        this.searchForm = App.getLocalStorage(STORAGE_KEY.PLAN_SEARCH)
      }
      this.searchForm.pageNo = this.pageNo
      this.searchForm.dataCount = this.dataCount
      this.onSearch(this.searchForm)
    },
    /** 絞り込み条件設定モーダルを開く */
    openSearchModal: function () {
      this.$refs.planSearchRef.showModal()
    },
    /** 表示項目切替モーダルを開く */
    openDispModal: function () {
      this.$emit('showDispModal')
    },
    /** 検索ボタン押下 */
    onClickSearch: function (searchForm) {
      this.pageNo = 1
      this.$refs.pagerRef.setCurrentPage(this.pageNo)
      searchForm.pageNo = this.pageNo
      searchForm.dataCount = this.dataCount
      this.onSearch(searchForm)
    },
    /** 絞り込み条件で検索 */
    onSearch: function (searchForm) {
      App.setLocalStorage(STORAGE_KEY.PLAN_SEARCH, searchForm)
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.LIST + '/rot-data', searchForm)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.planDataList = response.data.data.columnDataList
          this.dispPlanDataList = this.planDataList
          this.totalCount = response.data.data.totalCount
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 項目の表示・非表示判定 */
    checkDisp: function (num) {
      return !this.dispForm.rotCheckList.includes(num)
    },
    /** 数字ボタンが押すたびに動く処理 */
    paging: function (pageNo) {
      this.pageNo = pageNo
      this.searchForm = App.getLocalStorage(STORAGE_KEY.PLAN_SEARCH)
      this.searchForm.pageNo = this.pageNo
      this.searchForm.dataCount = this.dataCount
      this.onSearch(this.searchForm)
    },
    /** 出力プレビューの表示 */
    openPreview: function (rotCode) {
      let childWindow = window.open('/#/preview?rotCode=' + rotCode, 'sheet-page', 'width=1420, height=940')
      childWindow.location.reload()
    },
    /** CSV出力 */
    downLoadCsv: function () {
      axios.get(API_URL.LIST + '/download/' + LIST_TYPE.OUTPUT.code)
        .then(response => {
          let formatStr = moment().format('YYYYMMDDHHmmss')
          let arrayData = response.data.data
          let csvData = arrayData.map(function (l) { return l.join(',') }).join('\r\n')
          // SJISに変換する
          let sjisArray = encoding.convert(encoding.stringToCode(csvData), {to: 'SJIS'})
          let blob = new Blob([new Uint8Array(sjisArray)], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'RotList_' + formatStr + '.csv'
          link.click()
          let modalData = {
            messages: ['ファイルをダウンロードしました。']
          }
          App.showModal(modalData)
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    clear: function () {
      this.searchForm = {
        planStatus: [],
        estimateDateStart: '',
        estimateDateEnd: '',
        orderDateStart: '',
        orderDateEnd: '',
        manufactureDateStart: '',
        manufactureDateEnd: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        completeDateStart: '',
        completeDateEnd: '',
        planRotCode: '',
        umPlanid: '',
        businessName: '',
        fileName: '',
        pageNo: '',
        dataCount: ''
      }
    },
    getDispStatus: function (status) {
      if ([20, 50, 55].includes(status)) {
        return '生産指示済'
      }
      return ''
    },
    getFormatDate: function (date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    getFormatSimpleDate: function (date) {
      if (date) {
        return moment(date).format('M/DD')
      } else {
        return ''
      }
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  },
  beforeDestroy: function () {
    document.removeEventListener('mouseup', this.onMouseup)
  }
}
</script>

<style src="../../css/list/list.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#manufacture_table {
  height: 95%;
  width: 95%;
  padding: 10px 30px;
}
.title_area {
  color: #5F646F;
  background-color: #E4D3CE
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/OutputSheetTable.vue